module.exports = __webpack_public_path__ + "static/media/oc_house.7e07fb68.svg";